module.exports = __webpack_public_path__ + "static/media/vehicle-in-out.2b1c6d7c.jpg";